var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vue-tree-list",
    {
      staticStyle: { "font-size": "15px" },
      attrs: {
        model: _vm.data,
        loading: _vm.loading,
        "default-tree-node-name": "子模版",
        "default-leaf-node-name": "子模版",
        "default-expanded": false,
      },
      on: {
        click: _vm.onClick,
        "change-name": _vm.onChangeName,
        "delete-node": _vm.onDel,
        "add-node": _vm.onAddNode,
        drop: _vm.onDrop,
        "drop-before": _vm.onDropBefore,
        "drop-after": _vm.onDropAfter,
      },
      scopedSlots: _vm._u([
        {
          key: "leafNameDisplay",
          fn: function (slotProps) {
            return [
              slotProps.model.showCheckbox
                ? _c(
                    "Checkbox",
                    {
                      attrs: {
                        label: slotProps.model.id,
                        disabled: slotProps.model.disabled,
                      },
                      model: {
                        value: slotProps.model.checked,
                        callback: function ($$v) {
                          _vm.$set(slotProps.model, "checked", $$v)
                        },
                        expression: "slotProps.model.checked",
                      },
                    },
                    [_vm._v(_vm._s(slotProps.model.name))]
                  )
                : _c("span", [_vm._v(_vm._s(slotProps.model.name))]),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "span",
        {
          staticClass: "icon",
          attrs: { slot: "addLeafNodeIcon" },
          slot: "addLeafNodeIcon",
        },
        [_c("Icon", { attrs: { type: "md-add" } })],
        1
      ),
      _c(
        "span",
        {
          staticClass: "icon",
          attrs: { slot: "editNodeIcon" },
          slot: "editNodeIcon",
        },
        [_c("Icon", { attrs: { type: "ios-create-outline" } })],
        1
      ),
      _c(
        "span",
        {
          staticClass: "icon",
          attrs: { slot: "delNodeIcon" },
          slot: "delNodeIcon",
        },
        [_c("Icon", { attrs: { type: "md-close" } })],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }